'use client';
import React, { createContext } from 'react';
export const PopoverContext = createContext(undefined);
export const usePopoverContext = (currentComponent) => {
    const context = React.useContext(PopoverContext);
    if (context === undefined) {
        throw Error(`Popover ${currentComponent} must be used inside of a Popover, ` +
            'otherwise it will not function correctly.');
    }
    return context;
};
